import { createEffect, createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'

export const REAL = Symbol('REAL')
export const FAKE = Symbol('FAKE')

type DependencyType = typeof REAL | typeof FAKE
type DependencyMap = { [REAL]: () => void, [FAKE]: () => void, name?: string }

const dependencyMaps: Set<DependencyMap> = new Set()

export const [getDependencyType, setDependencyType] = createSignal<DependencyType>(REAL)

export const registerDependency = (map: DependencyMap) => {
  dependencyMaps.add(map)
  createEffect(() => {map[getDependencyType()]()})
}

export const resetDependencies = () => {
  dependencyMaps.forEach(map => map[getDependencyType()]())
}
